import React, { useEffect, useState } from "react";
import "../../assets/styles/card.css";
import BASE_URL from "../../config";

function SubscriptionCard() {
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("jwt_token");

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      try {
        const statusRes = await fetch(`${BASE_URL}/api/subscription/status/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!statusRes.ok) {
          throw new Error("Failed to fetch subscription status");
        }

        const statusData = await statusRes.json();
        setSubscriptionStatus(statusData);
      } catch (error) {
        console.error("Error fetching subscription data:", error);
        setSubscriptionStatus(null);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchSubscriptionData();
    }
  }, [token]);

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { label: "Active", color: "#4caf50" },
      past_due: { label: "Payment Failed", color: "#ff9800" },
      canceled: { label: "Canceled", color: "#9e9e9e" },
      suspended: { label: "Suspended", color: "#f44336" },
      inactive: { label: "Inactive", color: "#9e9e9e" },
      none: { label: "No Subscription", color: "#9e9e9e" },
    };

    const config = statusConfig[status] || { label: status || "Unknown", color: "#9e9e9e" };
    return (
      <span style={{
        backgroundColor: config.color,
        color: "white",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "0.85em",
        fontWeight: "bold"
      }}>
        {config.label}
      </span>
    );
  };

  // Hide the card if no active subscription
  if (loading || !subscriptionStatus || subscriptionStatus.status !== "active") {
    return null;
  }

  return (
    <article className="sub-card-container" aria-labelledby="sub-card-heading">
      <h2 id="sub-card-heading" className="sub-card-title">Subscription Summary</h2>

      <dl>
        <div className="sub-detail-row">
          <dt className="sub-label">Status</dt>
          <dd className="sub-value">{getStatusBadge(subscriptionStatus.status)}</dd>
        </div>
        <div className="sub-detail-row">
          <dt className="sub-label">Plan</dt>
          <dd className="sub-value">{subscriptionStatus.plan_name}</dd>
        </div>
        <div className="sub-detail-row">
          <dt className="sub-label">Monthly Price</dt>
          <dd className="sub-value">£{Number(subscriptionStatus.plan_price).toFixed(2)}/month</dd>
        </div>
        {subscriptionStatus.next_billing_date && (
          <div className="sub-detail-row">
            <dt className="sub-label">Next Billing</dt>
            <dd className="sub-value">{new Date(subscriptionStatus.next_billing_date).toLocaleDateString()}</dd>
          </div>
        )}
        {subscriptionStatus.grace_period_end && (
          <div className="sub-detail-row">
            <dt className="sub-label">Grace Period Ends</dt>
            <dd className="sub-value" style={{color: "#ff9800", fontWeight: "bold"}}>
              {new Date(subscriptionStatus.grace_period_end).toLocaleDateString()}
            </dd>
          </div>
        )}
      </dl>
    </article>
  );
}

export default SubscriptionCard;
